import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';
import { billingClient } from '@/lib/api/ts-rest';

/** The most recent not-yet-published run, to offer "Reprendre" on the index. */
export function useLatestActiveRun() {
  return useQuery({
    queryKey: queryKeys.billing.latestActive(),
    queryFn: async () => {
      const res = await billingClient.getLatestActiveRun();
      if (res.status !== 200) throw new Error('Failed to load run');
      return res.body;
    },
  });
}
